import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Logo from '../../components/Logo';
export default function Error404() {
    return (_jsxs(_Fragment, { children: [_jsx(Logo, {}), _jsxs("div", { className: "flex flex-col items-center justify-center w-full h-full mt-20", children: [_jsx("h1", { className: "text-5xl font-bold", children: "404" }), _jsx("h2", { className: "text-2xl font-bold", children: "Page not found" })] })] }));
}
